var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _vm._v(" Account Information "),
          _vm.editable
            ? [
                _c(
                  "gg-btn",
                  {
                    staticClass: "float-right",
                    attrs: {
                      depressed: "",
                      tile: "",
                      color: "primary"
                    },
                    on: {
                      click: _vm.openEditDialog
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        attrs: {
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v("Edit")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "visually-hidden text-lowercase"
                      },
                      [_vm._v(" Account information edit button ")]
                    )
                  ]
                ),
                _c("edit-profile-form", {
                  attrs: {
                    "modal-status": _vm.editDialog
                  },
                  on: {
                    close: _vm.closeEditDialog
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "gg-card-text",
        {
          staticClass: "pa-4"
        },
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                {
                  staticClass: "pa-0"
                },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [_vm._v("Name")]),
                      _c("v-list-item-title", {
                        domProps: {
                          innerHTML: _vm._s(_vm.name)
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-list-item",
                {
                  staticClass: "pa-0"
                },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [_vm._v("Address")]),
                      _c("v-list-item-title", [
                        _vm._v(
                          _vm._s(_vm.SessionProfile.address1) +
                            " " +
                            _vm._s(_vm.SessionProfile.address2)
                        )
                      ]),
                      _c("v-list-item-title", [
                        _vm._v(
                          _vm._s(_vm.SessionProfile.city) +
                            ", " +
                            _vm._s(_vm.SessionProfile.state) +
                            " " +
                            _vm._s(_vm.SessionProfile.postcode)
                        )
                      ]),
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.SessionProfile.country))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-list-item",
                {
                  staticClass: "pa-0"
                },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [_vm._v("Email")]),
                      _c("v-list-item-title", [
                        _vm._v(" " + _vm._s(_vm.SessionProfile.email) + " ")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-list-item",
                {
                  staticClass: "pa-0"
                },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [_vm._v("Phone number")]),
                      _c("v-list-item-title", [
                        _vm._v(
                          " " + _vm._s(_vm.SessionProfile.phonenumber) + " "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }